import { renderDsPanel } from '../../../../../shared-ui/ds/panel.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';

const PANEL_SIZES = new Set(['sm', 'md', 'lg']);
const PANEL_STATES = new Set(['Default', 'Focus', 'Disabled', 'Collapsed']);
const PANEL_MODES = new Set(['fixed', 'resizable', 'collapsible']);

export function renderSettingsPanel(options = {}) {
  const normalized = withSettingsPresentationMode(options);
  const size = PANEL_SIZES.has(normalized.size) ? normalized.size : 'md';
  const state = PANEL_STATES.has(normalized.state) ? normalized.state : 'Default';
  const mode = PANEL_MODES.has(normalized.mode) ? normalized.mode : 'fixed';
  const attrs = normalized && typeof normalized.attrs === 'object' && normalized.attrs
    ? { ...normalized.attrs }
    : normalized.attrs;
  const className = String(normalized.className || '').trim();

  return renderDsPanel({
    ...normalized,
    size,
    state,
    mode,
    attrs,
    className,
    footerHtml: normalized.footerHtml == null ? '' : normalized.footerHtml
  });
}
